import React, { useEffect, useState, useContext, useRef } from "react";
import CommonModal from "../../CommonElements/CommonModal/index";
import TariffModal from "../../CommonElements/TariffModal/TariffModal";
import { ModalBody } from "reactstrap";
import CorprateClientFlow from "../CorprateClientsFlow/CorprateClientFlow";
import TariffMenu from "./TariffMenu";
import TariffFlow from "./TariffFlow";
import SharedDataContext from "../../_helper/SharedData";
import { useTariffSearch } from "../../_helper/TariffSearchContext/TariffSeachContext";

function TariffMaster({ modal, setModal, flowType }) {
  const { setTabValue } = useContext(SharedDataContext);
  const {closeInputModal,setCloseInputModal} = useTariffSearch();

  const [isMenu, setIsMenu] = useState(true);
  const [isFlow, setIsFlow] = useState(false);
  const [tabName, setTabName] = useState("");
  const [modalTitle,setModalTitle] = useState("Tariff");
  
  // Ref to store the close warning handler from child component
  const closeWarningHandlerRef = useRef(null);
  
  useEffect(()=>{
    setTabValue(0)
  },[])

  useEffect(() => {
    console.log("tabName is ", tabName);
  }, [tabName]);

  const handleCloseModal=()=>{
    setModalTitle("Create Tariff")
    setIsFlow(false);
    setIsMenu(true);
    setModal(false);
    setCloseInputModal(false);
  };

  // Handle modal close - check if child has a warning handler
  const handleModalToggle = () => {
    if ((flowType === 'clientsBulkCreate' || flowType === 'packagesBulkCreate' ) && closeWarningHandlerRef.current) {
      closeWarningHandlerRef.current();
    } else {
      handleCloseModal();
    }
  };

  // Register close warning handler from child
  const registerCloseHandler = (handler) => {
    closeWarningHandlerRef.current = handler;
  };

  const handleTabsClick=(tabName)=>{

    setTabName(tabName);
    setIsFlow(!isFlow);
    setIsMenu(!isMenu);
    setModalTitle(tabName);
    handleChangeTitle(tabName);
  };

  const handleChangeTitle = (tabName) => {
    const title = "Create " + tabName;
    console.log(title);
    setModalTitle(title);
  };

  const changeTitle = (title) => {
    setModalTitle(title);
  };

  useEffect(() => {
    if (modal || closeInputModal) {
      if (flowType === "client") {
        setTabName("Corporate Client");
        setModalTitle("Create Corporate Client");
      } else if (flowType === "package") {
        setTabName("Package");
        setModalTitle("Create Package");
      } else if (flowType === "rate") {
        setTabName("Package Rates");
        setModalTitle("Create Rate");
      } else if (flowType === "packagesBulkCreate") {
        setTabName("Bulk Create");
        setModalTitle("Create Packages");
      } else if (flowType === "clientsBulkCreate") {
        setTabName("Corp Bulk Create");
        setModalTitle("Create Clients");
      }
      setIsMenu(false);
      setIsFlow(true);
    }
  }, [modal, flowType,closeInputModal]);

  return (
    <>
      <TariffModal
        isOpen={closeInputModal}
        size="xl"
        centered
        toggler={handleModalToggle}
        title={modalTitle}
      >
        {/* {isMenu ? <TariffMenu handleClick={handleTabsClick} /> : ""} */}

        {isFlow ? (
          <TariffFlow
            tabName={tabName}
            setTitle={changeTitle}
            flowType={flowType}
            handleCloseModal={handleCloseModal}
            registerCloseHandler={registerCloseHandler}
          />
        ) : (
          ""
        )}
      </TariffModal>
    </>
  );
}

export default TariffMaster;
